/**
 *
 * @module streamSamplePayload
 *
 */

import Check from 'check-types';
import InvalidArgumentException from '../../exception/invalidArgumentException';

import StreamSampleClientPayload from './streamSampleClientPayload';

const {
    instanceStrict,
    object
} = Check.assert;

/**
 *
 * @class StreamSamplePayload
 * @since 3.5.0
 * @implements {TelemetryPayload}
 *
 */
export default class StreamSamplePayload {

    /**
     *
     * @param {Object} server
     * @param {Object} client
     *
     */
    constructor(server, client) {

        const errorMessage = {
            ctor: 'StreamSampleEvent(server, client)',
            get server() {
                return `${this.ctor} needs a server data Object`;
            },
            get client() {
                return `${this.ctor} needs SDK.Services.Internal.Telemetry.StreamSampleClientPayload instance`;
            }
        };

        object(server, errorMessage.server, InvalidArgumentException);
        instanceStrict(client, StreamSampleClientPayload, errorMessage.client, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {Object}
         * @desc Dictionary containing server provided tracking information.
         * @note this can be an empty object
         *
         */
        this.server = server;

        /**
         *
         * @access public
         * @type {Object}
         * @desc Dictionary containing client provided tracking information.
         *
         */
        this.client = client;

    }

}



// WEBPACK FOOTER //
// ./src/services/internal/telemetry/streamSamplePayload.js